<template>
  <div class="homePage-view">
    <new-home></new-home>
    <div class="panelOne">
      <sidebar-one></sidebar-one>
      <div class="right-view">
        <menu-list></menu-list>
        <div class="crousel-view">
          <div class="crousel-swiper">
            <el-carousel trigger="click" height="365px" arrow="always">
              <el-carousel-item v-for="(item,index) in swiperList" :key="index">
                <img :src="item.img" alt="" style="width:100%;height:100%" @click="imgClick(item)">
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="crousel-right">
            <!-- <div class="notice">
              <p>公告</p>
              <ul>
                <li v-for="(item,index) in noticeList" :key="index">
                  <router-link to="">
                    <span>·</span>
                    {{item.text}}
                  </router-link>
                </li>
              </ul>
            </div> -->
            <div class="today-discount">
              <p class="today-title">免费专区</p>
              <el-carousel trigger="click" height="325px" indicator-position="none" arrow="always">
                <el-carousel-item v-for="(item,index) in discountList" :key="index">
                  <img :src="item.imgUrl" alt="" @click="goGoodsDetails(item.id)">
                  <p>{{item.text}}</p>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <recommend-five></recommend-five> -->
    <recommend-one style="margin-top: 0"></recommend-one>
    <recommend-two></recommend-two>
    <recommend-three></recommend-three>
    <!-- <recommend-four></recommend-four> -->
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarOne from '@/base/sidebar1/sidebar1'
import RecommendOne from './recommendOne'
import RecommendTwo from './recommendTwo'
import RecommendThree from './recommendThree'
import RecommendFour from './recommendFour'
import RecommendFive from './recommendFive'
import NewHome from '@/components/NewHome/newHome'
export default {
  name: 'homePage',
  components: {
    'menu-list': Menu,
    'sidebar-one': SidebarOne,
    'recommend-one': RecommendOne,
    'recommend-two': RecommendTwo,
    'recommend-three': RecommendThree,
    'recommend-four': RecommendFour,
    'recommend-five': RecommendFive,
    'new-home': NewHome
  },
  data () {
    return {
      msg: '首页',
      swiperList: [],
      noticeList: [{
        text: '弘扬社会主义价值观哈哈哈哈哈'
      }, {
        text: '教育部推荐学生必读'
      }, {
        text: '5月行书'
      }],
      discountList: []
    }
  },
  methods: {
    getBannerAd () {
      this.$get(this.$allUrl.getBannerAd).then(res => {
        if (res.code === '0') {
          const list = res.data
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach((e, i) => {
            this.swiperList.push({
              img: imgAdmin + e.imageUrl,
              id: e.id,
              adType: e.adType,
              target: e.target
            })
          })
        }
      })
    },
    getFreeShelfBooks (start) {
      const par = `?start=0&num=10000`
      this.$get(this.$allUrl.getFreeShelfBooks + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          this.discountList = []
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.discountList.push({
              id: e.bookId,
              text: e.bookName,
              imgUrl: imgAdmin + e.coverUrl
            })
          })
        }
      })
    },
    imgClick (obj) {
      if (obj.adType === 1) {
        this.$router.push({
          name: 'GoodsDetails',
          query: {
            id: obj.target
          }
        })
      } else {
        window.open(obj.target)
      }
    },
    goGoodsDetails (id) {
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    this.getBannerAd()
    this.getFreeShelfBooks()
  }
}
</script>
<style lang="less" scoped>
  @font-size: 14px;
  @hoverColor: red;
  .homePage-view{
    padding-top: 20px;
    .panelOne{
      display: flex;
      .right-view{
        flex: 1;
        .crousel-view{
          margin-top: 10px;
          height: 400px;
          margin-left: 10px;
          display: flex;
          .crousel-swiper{
            margin-right: 10px;
            flex: 1;
            height: 100%;
          }
          .crousel-right{
            width: 250px;
            .notice{
              padding: 10px;
              border: 1px solid #CCCCCC;
              p{
                margin: 0;
              }
              ul{
                margin: 0;
                padding: 0;
                margin-top: 10px;
                font-size: @font-size;
                list-style: none;
                li{
                  width: 100%;
                  overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;
                  padding: 2px 0;
                  a{
                    color: black;
                    text-decoration: none;
                  }
                  a:hover{
                    color: @hoverColor;
                  }
                }
              }
            }
            .today-discount{
              border: 1px solid #CCCCCC;
              text-align: center;
              vertical-align: middle;
              background-color: antiquewhite;
              font-size: @font-size;
              .today-title{
                text-align: left;
                padding: 0 10px;
                height: 38px;
                line-height: 38px;
                margin: 0;
                font-size: @font-size + 2px;
              }
              img{
                width: 100px;
                vertical-align: middle;
                margin-top: 40px;
                cursor: pointer;
                // display: block;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/homePage.vue


// WEBPACK FOOTER //
// src/components/Home/homePage.vue